#ifdef USE_TANGENT

#define vGlitterUV vBumpUV

vec3 bitangent = normalize(cross(vt.rgb, vn));
mat3 TBN = mat3(vt.rgb, bitangent, normalize(vn));

if (glitterScale > 0.0) {
    vec2 glitterNormalCoords = vGlitterUV * glitterScale;
    // This should be viewDirection in object space
    mat3 invTBN = transposeMat3(TBN);
    vec3 viewDirectionW = normalize(cameraPosition - vPositionW);
    vec3 tanViewDir = invTBN * viewDirectionW;
    float glitterDepthScale = 1.0;
    float height = texture2D(glitterNoiseTexture, glitterNormalCoords).r;
    vec2 glitterUVOffset = -glitterDepthScale * tanViewDir.xy * height;
    // The normal for the piece of glitter you'd see at this angle
    vec3 glitterNormalMap = texture2D(glitterNoiseTexture, glitterNormalCoords + glitterUVOffset).rgb;
    // [0, 1] => [-0.5, 0.5] 
    glitterNormalMap = glitterNormalMap -= 0.5;

    vec3 glitterColor = vec3(0.0);
    if (length(glitterNormalMap) > 0.1) {
        // then normalize to [-1, 1]
        glitterNormalMap = normalize(glitterNormalMap);

        vec3 l = -vPositionW.xyz;
        vec3 r = normalize(reflect(l, glitterNormalMap));
        float glitterReflectance = max(0., dot(viewDirectionW, r));

        glitterReflectance = pow(glitterReflectance, 2.0);
        if (glitterReflectance > 0.0) {
            glitterColor = texture2D(glitterPatternTexture, glitterNormalCoords).rgb;
            glitterColor = (1.0 - height) * glitterReflectance * glitterColor;
        }

        gl_FragColor = vec4(gl_FragColor.rgb + glitterColor, gl_FragColor.a);
    }
}

#endif
